var poll_default = {
  "fontElementMap": "FliGG",
  "container": "nZ9ha",
  "fullscreen": "J5lIP",
  "background_overlay": "gzrZZ",
  "with_image": "Ps8xP",
  "options": "_5mqD6",
  "webview": "_2xqY-",
  "grid": "_9SXvf",
  "option": "_3eSlM",
  "cta_button": "s-uXA",
  "add_option": "jqkb2",
  "see_more": "NuSqK",
  "list": "w5eHW",
  "column": "_6X4ec",
  "additional_note": "_2ybei",
  "spinner": "q1nqw",
  "spin": "PqWdg",
  "shown": "t4dDi",
  "error": "_9y0T3"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
